(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["melodietje-countdown"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.currentScript && document.currentScript.closest
      ? document.currentScript.closest('.countdown')
      : null;
    // currentScript not reliable inside {% javascript %}; fall back to last uninitialised node
    var nodes = document.querySelectorAll('.countdown[data-target]:not([data-cd-init])');

    nodes.forEach(function (el) {
      el.setAttribute('data-cd-init', '1');

      var target = new Date(el.getAttribute('data-target')).getTime();
      if (isNaN(target)) return;

      var live = el.querySelector('[data-countdown-live]');
      var expired = el.querySelector('[data-countdown-expired]');
      var elD = el.querySelector('[data-d]');
      var elH = el.querySelector('[data-h]');
      var elM = el.querySelector('[data-m]');
      var elS = el.querySelector('[data-s]');

      function pad(n) { return n < 10 ? '0' + n : '' + n; }

      function showExpired() {
        if (live) live.hidden = true;
        if (expired) expired.hidden = false;
      }

      function tick() {
        var diff = target - Date.now();
        if (diff <= 0) {
          showExpired();
          return false;
        }
        var s = Math.floor(diff / 1000);
        var d = Math.floor(s / 86400); s -= d * 86400;
        var h = Math.floor(s / 3600); s -= h * 3600;
        var m = Math.floor(s / 60); s -= m * 60;
        if (elD) elD.textContent = pad(d);
        if (elH) elH.textContent = pad(h);
        if (elM) elM.textContent = pad(m);
        if (elS) elS.textContent = pad(s);
        return true;
      }

      if (tick() === false) return;
      var iv = setInterval(function () {
        if (tick() === false) clearInterval(iv);
      }, 1000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["melodietje-hero-content"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var btn = document.querySelector('.hero__sample');
    var audio = document.querySelector('.hero__sample-audio');
    if (!btn || !audio) return;

    btn.addEventListener('click', function () {
      if (audio.paused) {
        audio.play().catch(function () {});
      } else {
        audio.pause();
      }
    });

    audio.addEventListener('play', function () { btn.setAttribute('aria-pressed', 'true'); });
    audio.addEventListener('pause', function () { btn.setAttribute('aria-pressed', 'false'); });
    audio.addEventListener('ended', function () { audio.currentTime = 0; });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["melodietje-keepsake"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-keepsake]').forEach((section) => {
    const flip = section.querySelector('[data-flip]');
    const buttons = section.querySelectorAll('[data-face]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // The bundle promise (€79 combo) only holds once the keepsake product exists
    // in Shopify. Until then, fall back to the song-only CTA.
    const buy = section.querySelector('[data-bundle-handle]');
    if (buy) {
      const handle = (buy.dataset.bundleHandle || '').trim();
      const degrade = () => {
        section.classList.add('keepsake--no-bundle');
        const solo = section.querySelector('.keepsake__cta--solo');
        if (solo && buy.dataset.soloFallback) solo.textContent = buy.dataset.soloFallback;
      };
      if (!handle) {
        degrade();
      } else {
        fetch('/products/' + handle + '.js')
          .then((r) => { if (!r.ok) degrade(); })
          .catch(() => {});
      }
    }

    let userInteracted = false;
    let inView = false;
    let autoTimer = null;

    // Kaderkleur (oak/black) + Versie (front/back) pick the exact variant; the
    // combo CTA carries it as ?kpv= so the funnel adds what the visitor chose.
    const scene = section.querySelector('.kp-scene');
    const swatches = section.querySelectorAll('.kp-swatch');
    const combo = section.querySelector('.keepsake__cta--combo');

    const currentVariantId = () => {
      const kader = scene.classList.contains('kp--zwart') ? 'zwart' : 'eik';
      const versie = flip.classList.contains('is-flipped') ? 'volledig' : 'refrein';
      const img = section.querySelector('.kp-photo img[data-kader="' + kader + '"][data-versie="' + versie + '"]');
      return img ? img.dataset.variantId : '';
    };

    const syncComboHref = () => {
      if (!combo) return;
      const href = combo.getAttribute('href') || '';
      if (href.indexOf('keepsake=1') === -1) return;
      const vid = currentVariantId();
      if (!vid) return;
      const url = new URL(href, window.location.origin);
      url.searchParams.set('kpv', vid);
      combo.setAttribute('href', url.pathname + url.search);
    };

    swatches.forEach((btn) => {
      btn.addEventListener('click', () => {
        scene.classList.toggle('kp--zwart', btn.dataset.kader === 'zwart');
        swatches.forEach((b) => {
          const active = b === btn;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-pressed', String(active));
        });
        syncComboHref();
      });
    });

    const setFace = (face) => {
      flip.classList.toggle('is-flipped', face === 'back');
      buttons.forEach((btn) => {
        const active = btn.dataset.face === face;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', String(active));
      });
      section.querySelector('.kp-face--front').setAttribute('aria-hidden', String(face === 'back'));
      section.querySelector('.kp-face--back').setAttribute('aria-hidden', String(face !== 'back'));
      syncComboHref();
    };

    syncComboHref();

    buttons.forEach((btn) => {
      btn.addEventListener('click', () => {
        userInteracted = true;
        if (autoTimer) clearInterval(autoTimer);
        setFace(btn.dataset.face);
      });
    });

    // Auto-turn the frame once in a while until the visitor takes over.
    const startAuto = () => {
      if (reducedMotion || userInteracted || autoTimer) return;
      autoTimer = setInterval(() => {
        if (!inView || userInteracted) return;
        setFace(flip.classList.contains('is-flipped') ? 'front' : 'back');
      }, 6500);
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          inView = entry.isIntersecting;
          if (entry.isIntersecting) {
            section.classList.add('is-inview');
            startAuto();
          }
        });
      },
      { threshold: 0.25 }
    );
    observer.observe(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["melodietje-poster-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-poster-hero]').forEach((root) => {
    const shots = root.querySelectorAll('.ph__shots img');
    const swatches = root.querySelectorAll('.ph__swatch');
    const toggles = root.querySelectorAll('.ph__toggle-btn');
    if (!shots.length) return;

    let kader = 'eik';
    let versie = 'refrein';

    const render = () => {
      let variantId = '';
      root.classList.toggle('ph--no-callout', versie === 'volledig');
      shots.forEach((img) => {
        const match = img.dataset.kader === kader && img.dataset.versie === versie;
        img.classList.toggle('is-active', match);
        if (match) variantId = img.dataset.variantId || '';
      });
      if (!variantId) return;

      /* Every bundle CTA on the page — hero, steps, reviews, final CTA — carries
         the frame the visitor picked here. Someone who scrolls and converts
         further down never has to come back up to choose one, and the funnel's
         upsell card stays uncheckable if they change their mind. Links without
         keepsake=1 (the song-only escape hatches) are left alone. */
      document.querySelectorAll('a[href*="keepsake=1"]').forEach((link) => {
        const url = new URL(link.getAttribute('href'), window.location.origin);
        url.searchParams.set('kpv', variantId);
        link.setAttribute('href', url.pathname + url.search);
      });
    };

    swatches.forEach((btn) => {
      btn.addEventListener('click', () => {
        kader = btn.dataset.kader;
        swatches.forEach((b) => {
          const active = b === btn;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-pressed', String(active));
        });
        render();
      });
    });

    toggles.forEach((btn) => {
      btn.addEventListener('click', () => {
        versie = btn.dataset.versie;
        toggles.forEach((b) => {
          const active = b === btn;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-pressed', String(active));
        });
        render();
      });
    });

    render();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["melodietje-vaderdag-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* sample audio toggle */
    var btn = document.querySelector('.hero__sample');
    var audio = document.querySelector('.hero__sample-audio');
    if (btn && audio) {
      btn.addEventListener('click', function () {
        if (audio.paused) { audio.play().catch(function () {}); } else { audio.pause(); }
      });
      audio.addEventListener('play', function () { btn.setAttribute('aria-pressed', 'true'); });
      audio.addEventListener('pause', function () { btn.setAttribute('aria-pressed', 'false'); });
      audio.addEventListener('ended', function () { audio.currentTime = 0; });
    }

    /* countdown */
    document.querySelectorAll('.hero__countdown[data-target]:not([data-cd-init])').forEach(function (el) {
      el.setAttribute('data-cd-init', '1');
      var target = new Date(el.getAttribute('data-target')).getTime();
      if (isNaN(target)) return;
      var live = el.querySelector('[data-cd-live]');
      var expired = el.querySelector('[data-cd-expired]');
      var elD = el.querySelector('[data-d]'), elH = el.querySelector('[data-h]'),
          elM = el.querySelector('[data-m]'), elS = el.querySelector('[data-s]');
      function pad(n) { return n < 10 ? '0' + n : '' + n; }
      function tick() {
        var diff = target - Date.now();
        if (diff <= 0) {
          if (live) live.hidden = true;
          if (expired) expired.hidden = false;
          return false;
        }
        var s = Math.floor(diff / 1000);
        var d = Math.floor(s / 86400); s -= d * 86400;
        var h = Math.floor(s / 3600); s -= h * 3600;
        var m = Math.floor(s / 60); s -= m * 60;
        if (elD) elD.textContent = pad(d);
        if (elH) elH.textContent = pad(h);
        if (elM) elM.textContent = pad(m);
        if (elS) elS.textContent = pad(s);
        return true;
      }
      if (tick() === false) return;
      var iv = setInterval(function () { if (tick() === false) clearInterval(iv); }, 1000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["melodietje-video-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var btn = document.querySelector('[data-video-hero-btn="{{ section.id }}"]');
    if (!btn) return;

    var hero = document.getElementById('video-hero-{{ section.id }}');
    var video = hero ? hero.querySelector('.video-hero__video') : null;
    if (!btn || !video) return;

    btn.addEventListener('click', function () {
      video.muted = !video.muted;
      if (video.muted) {
        video.currentTime = 0;
        video.play();
        btn.setAttribute('aria-pressed', 'false');
        hero.removeAttribute('data-audio-on');
      } else {
        video.currentTime = 0;
        video.play();
        btn.setAttribute('aria-pressed', 'true');
        hero.setAttribute('data-audio-on', '');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
